<template>
  <div class="details" v-if="coldata">
    <header>
      <div class="search">
        <router-link :to="{ name: 'Live' }"><img src="../../assets/images/logo.jpg" alt="" /></router-link>
      </div>
    </header>

    <div class="details_wrap">
      <div class="cover">
        <img v-if="coldata.colThumbnailUrl" class="con_images" :src="coldata.colThumbnailUrl" alt="" />
        <img class="con_images" src="../../assets/images/default.png" alt="" v-else />
      </div>
      <div class="title">
        <div class="img_text">
          <p class="line_title">{{ coldata.colTitle }}</p>
          <p>{{ getTimes(coldata.colCreateDt) }}</p>
        </div>

        <div class="img_text">
          <p v-if="coldata.entity">{{ coldata.entity.eName }}</p>

          <div>
            <span class="colOrder">参会人数：{{ coldata.orderNum ? coldata.orderNum : 0 }}</span>
            <img src="../../assets/images/sc.png" alt v-if="coldata.colIsCollect == 1" @click="sc(1)" />
            <img src="../../assets/images/unsc.png" v-else="!coldata.colIsCollect" @click="sc(0)" alt />
            <span>{{ texts }}</span>
          </div>
        </div>
      </div>
      <div class="navigation">
        <ul class="tabmenus">
          <li v-for="(item, index) in menulist" @click="tablist(index)" :class="{ active: active == index }">
            <span>{{ item.name }}</span>
          </li>
          <button class="jionpay" v-show="isCharge" @click="funisCharge">
            <span v-if="isfree == 0">我要参会￥{{ curPrice }}</span>
            <span v-if="isfree == 1">免费参会</span>
            <span v-if="isfree == 2">会员免费</span>
          </button>
          <button class="jionpay" v-show="!isCharge">
            <span v-if="isfree == 3">已购买</span>
          </button>
        </ul>
      </div>
    </div>

    <div class="box">
      <!--课程介绍-->
      <div v-if="active == 0" class="course">
        <i-course v-if="
          coldata.colDesc != undefined &&
          coldata.colDesc != null &&
          coldata.colDesc != ''
        " :value="coldata.colDesc"></i-course>
      </div>

      <div class="container" v-if="active == 1">
        <div class="item_list">
          <div v-if="columnList.length > 0" class="liveswill" style="height: 260px" v-for="(item, index) in columnList"
            :key="'liveswill' + index">
            <div class="con" @click="toDetails(item.relId, item.type)">
              <p class="item_type">
                <span v-if="item.type == 2">视频类型</span>
                <span v-if="item.type == 1">直播类型</span>
              </p>
              <img class="con_images" :src="item.picUrl" alt="" v-if="item.picUrl" />
              <img class="con_images" src="../../assets/images/default.png" alt="" v-else />
              <div class="con_right">
                <p class="con_title">{{ item.title }}</p>
                <div>
                  <p class="con_author">{{ item.teacher }}</p>
                  <p v-if="item.type == 1" class="item_type">
                    {{ getTimes(item.createTime) }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <img src="../../assets/images/nothing.png" alt="" v-if="columnList.length < 1" class="nothing" />
        </div>
      </div>

      <!--相关会议-->

      <div class="container" v-if="active == 2">
        <div class="item_list">
          <div class="liveswill" v-for="(item, index) in relatedList" :key="'liveswill' + index">
            <div class="con" @click="toDetails(item.colId, 0)">
              <p class="item_title">
                <span class="title_name">{{ item.egName }}频道</span>
                <span class="title_time">{{ getTimes(item.colCreateDt) }}</span>
              </p>
              <img class="con_images" :src="item.colThumbnailUrl" alt="" v-if="item.colThumbnailUrl" />
              <img class="con_images" src="../../assets/images/default.png" alt="" v-else />
              <div class="con_right">
                <p class="con_title">{{ item.colTitle }}</p>
                <div>
                  <p class="con_author">{{ item.entity.eName }}</p>
                  <div class="con_bt">
                    <span>参会人数：{{ item.orderNum }}</span>
                    <span class="con_bt_r" v-if="item.colIsCharge * 1 && !item.buyed">
                      <!--<s>¥{{item.originalPrice}}</s>-->
                      <span>¥{{ item.colFees }}</span>
                    </span>
                    <span class="con_bt_r" style="font-size: 0.26rem" v-if="item.colIsCharge * 1 && item.buyed">
                      已购
                    </span>

                    <span class="con_bt_r" style="font-size: 0.26rem" v-if="item.colIsCharge * 1 == 0">
                      免费
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="支付提示" :visible.sync="payqrcode" :close-on-click-modal="false" width="30%"
      :before-close="handleClose" v-if="isCharge">
      <div style="text-align: center" v-if="payqrcode">
        <p>支付金额：{{ this.curPrice }}元</p>
        <p>请微信扫码支付</p>
        <p>购买后有效期半年可看</p>
        <span id="con_qrcode" ref="qrcode"></span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import iCourse from "../container/course";
import QRCode from "qrcodejs2"; //二维码
import loginService from "../../plugin/extendFn/loginService";
import AppSetting from "../../AppSetting";
export default {
  data() {
    return {
      isVipBuy: 0,
      isfree: 0,
      payqrcode: false,
      columnList: [],
      active: 0,
      coldata: null,
      texts: "收藏",
      menulist: [
        { name: "会议简介" },
        { name: "会议课程" },
        { name: "相关会议" },
      ],
      wxuser: null,
      relatedList: [],
      timer: null,
    };
  },
  props: {},
  methods: {
    login() {
      loginService.login(this.$router).then((loginUser) => {
        this.wxuser = loginUser;
      });
    },
    async subscribe() {
      if (this.payfl == 1) {
        this.$message.warning("请勿重复点击！");
        return false;
      }

      if (await loginService.isNotLogin()) {
        this.login();
      } else {
        let wxuser = await loginService.getLoginUser();

        if (wxuser.uPhone && wxuser.uOrg) {
          this.payfl = 1;
          if (this.curPrice != 0) {
            this.payqrcode = true;
          }
          let param = {
            type: 1,
            orderType: this.$route.query.type == "column" ? 3 : "", //vip购买，1 视频购买，2直播购买，3专栏购买
            bId: this.$route.query.colId,
            originalPrice: this.oriPrice,
            payPrice: this.curPrice,
            uid: wxuser.uId,
            isVipBuy: this.isVipBuy,
          };
          this.$postHttp(AppSetting.baseUrl + "/order/app/add", param).then(
            (res) => {
              if (res.data.code == 0) {
                if (this.curPrice == 0) {
                  this.$message.success("支付成功！");
                  location.reload();
                  return false;
                }

                const pay_params = JSON.parse(res.data.parMap);

                const orderid = res.data.id; //订单号 用于查询支付状态
                console.log("支付信息", pay_params);
                let qrcode = new QRCode(this.$refs.qrcode, {
                  text: pay_params.code_url,
                  width: 200,
                  height: 200,
                  colorDark: "#333333", //二维码颜色
                  colorLight: "#ffffff", //二维码背景色
                  correctLevel: QRCode.CorrectLevel.H, //容错率，L/M/H
                });

                this.timer = setInterval(() => {
                  this.$postHttp(AppSetting.baseUrl + "/order/app/search", {
                    id: orderid,
                  }).then((result) => {
                    console.log(result);
                    if (result.data.code == 0) {
                      //data.orderStatus 0未支付，1支付成功，2支付失败
                      if (result.data.data.orderStatus == 1) {
                        this.$message.success("支付成功！");
                        document.getElementById("con_qrcode").innerHTML = "";
                        window.clearInterval(this.timer);
                        location.reload();
                        this.payqrcode = false;
                      } else if (result.data.data.orderStatus == 2) {
                        this.$message.success("支付失败！");
                        window.clearInterval(this.timer);
                        document.getElementById("con_qrcode").innerHTML = "";
                        this.payqrcode = false;
                      }
                    } else if (result.data.code == 2004) {
                      this.$message.error("订单号为空");
                    } else {
                      this.$message.error("查询失败");
                    }
                  });
                }, 2000);
              } else {
                this.$message.error(res.data.msg);
              }
            }
          );
        }
      }
    },

    funisCharge() {
      this.subscribe();
    },

    handleClose() {
      document.getElementById("con_qrcode").innerHTML = "";
      this.payqrcode = false;
      this.payfl = 0;
      window.clearInterval(this.timer);
    },

    async sc(type) {
      if (await loginService.isNotLogin()) {
        this.login();
      } else {
        this.ra_wxUser = await loginService.getLoginUser();

        if (type == 0) {
          this.$postHttp(AppSetting.baseUrl + "/column/collection", {
            uid: this.ra_wxUser.uId,
            id: this.coldata.colId,
          }).then((res) => {
            // bus.$emit('isstop','stop')
            if (res.data.code == 0) {
              this.texts = "已收藏";
              this.coldata.colIsCollect = 1;
              this.$message({
                message: "收藏成功！",
                type: "success",
              });
            } else {
              this.$message({
                message: "收藏失败！",
                type: "error",
              });
            }
          });
        } else {
          // bus.$emit('isstop','stop')
          weui.dialog({
            content: "确定要取消收藏吗？",
            className: "yors",
            buttons: [
              {
                label: "取消",
                type: "default",
                onClick: (res) => { },
              },
              {
                label: "确定",
                type: "primary",
                onClick: () => {
                  this.$postHttp(AppSetting.baseUrl + "/column/collection/cancel", {
                    uid: this.ra_wxUser.uId,
                    id: this.coldata.colId,
                  }).then((res) => {
                    if (res.data.code == 0) {
                      this.texts = "收藏";
                      this.coldata.colIsCollect = 0;
                      this.$message({
                        message: "取消收藏成功！",
                        type: "success",
                      });
                    } else {
                      this.$message({
                        message: "取消收藏失败！",
                        type: "eroor",
                      });
                    }
                  });
                },
              },
            ],
          });
        }
      }
    },

    getTimes(value) {
      return new Date(value).Format("yyyy.MM.dd hh:mm");
    },
    tablist(type) {
      this.active = type;
    },
    toDetails(id, type) {
      if (type == 1) {
        //直播

        if (this.isCharge) {
          //需要付费
          this.$message.warning("当前课程不支持观看，请先参会");
        } else {
          this.$router.push({
            name: "Details",
            query: { type: "live", liveId: id },
          });
        }
      } else if (type == 2) {
        //视频
        if (this.isCharge) {
          this.$message.warning("当前课程不支持观看，请先参会");
        } else {
          this.$router.push({
            name: "vDetails",
            query: { type: "video", videoId: id },
          });
        }
      } else if (type == 0) {
        //专栏详情
        this.$router.push({
          name: "colDetails",
          query: { type: "column", colId: id },
        });
        window.location.reload();
      }
    },
    async listdata(id) {
      if (await loginService.isNotLogin()) {
        this.login();
      } else {
        this.$postHttp(AppSetting.baseUrl + "/column/info", {
          id: id,
          uid: this.wxuser.uId,
        }).then((res) => {
          if (res.data.code == 0) {
            this.coldata = res.data.data;
            let author = this.coldata.auths.filter((v) => v.memId === 1);
            console.log(author);

            this.relatedList = res.data.relatedList; //相关会议 专栏
            this.curPrice = this.coldata.colFees;
            this.isVipBuy = res.data.isfree;
          }
        });
        this.$postHttp(AppSetting.baseUrl + "/column/rel/list", {
          id: id,
          uid: this.wxuser.uId,
        }).then((res) => {
          if (res.data.code == 0) {
            this.columnList = res.data.list;
          }
        });
      }

    },
  },
  components: {
    iCourse,
  },
  computed: {
    isCharge() {
      let status = true;
      if (this.coldata.buyed) {
        this.isfree = 3;
        status = false;
      } else if (this.coldata.colIsCharge == 0) {
        //0免费
        this.isfree = 1;
        this.curPrice = "0";
        //status = false
      } else if (this.isVipBuy == "1") {
        //会员免费
        this.isfree = 2;
        this.curPrice = "0";
        //status = false
      }

      console.log(this.isfree);
      return status;
    },
  },
  async mounted() {
    this.wxuser = await loginService.getLoginUser();

    this.listdata(this.$route.query.colId);
  },
};
</script>
<style scoped lang="scss">
#con_qrcode {
  width: 200px;
  height: 200px;
  margin: 20px auto;
  display: inline-block;
}

.jionpay {
  cursor: pointer;
  position: absolute;
  right: 20px;
  background: #007fff;
  color: #ffffff;
  border-radius: 5px;
  width: 120px;
  height: 30px;
  line-height: 30px;
  border: none;
  outline: none;
}

.course {
  width: 900px;
  height: 800px;
  margin: 0 auto;
  overflow-y: scroll;
}

.con_bt {
  font-size: 14px;
  color: #999999;
  overflow: hidden;
  line-height: 30px;

  span:first-child {
    float: left;
  }

  s {
    font-size: 14px;
    color: #999999;
  }
}

.con_bt_r {
  font-size: 16px;
  float: right;
  color: #f00000;
}

.con_images {
  width: 212px;
  height: 134px;
  border-radius: 5px;
}

.liveswill {
  border: 1px solid #e6e6e6;
  height: 280px;
  text-align: left;
  border-radius: 5px;
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  width: 232px;
  cursor: pointer;
  padding: 0 10px;

  float: left;
  margin: 24px 24px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-pack: justify;
  -webkit-box-pack: justify;
  justify-content: flex-start;

  .con {
    margin-top: 6px;
  }

  .item_title {
    padding-top: 6px !important;
    font-size: 12px;
    margin-bottom: 5px;
    display: flex;
    justify-content: space-between;

    .title_name {
      color: #666666;
      width: 110px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 1;
      /*限制文本行数*/
      /*white-space: nowrap;      !*超出的空白区域不换行*!*/
      overflow: hidden;
      /*超出隐藏*/
      text-overflow: ellipsis;
      /*文本超出显示省略号*/
    }

    .title_time {
      color: #999999;
    }
  }

  .title_name,
  .item_type {
    font-size: 12px;
    color: #666666 !important;
    display: flex;
    justify-content: space-between;
  }

  .item_type {
    padding-bottom: 5px;
    box-sizing: border-box;
  }

  .con_images {
    width: 212px !important;
    height: 134px !important;
    border-radius: 5px !important;
  }

  .con_title {
    font-size: 14px !important;
    color: #333 !important;
    line-height: 18px !important;
    height: 39px !important;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    /*设置弹性盒模型子元素的排列方式*/
    -webkit-line-clamp: 2;
    /*限制文本行数*/
    /*white-space: nowrap;      !*超出的空白区域不换行*!*/
    overflow: hidden;
    /*超出隐藏*/
    text-overflow: ellipsis;
    /*文本超出显示省略号*/
  }

  .con_author {
    font-size: 12px !important;
    font-weight: 300 !important;
    color: #666666 !important;
    min-height: 14px !important;
    margin-top: 5px !important;
  }

  .last {
    padding: 0px !important;
    box-sizing: border-box !important;
    margin-top: 6px !important;
    height: 20px;
  }
}

.item_list {
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
}

.container_item {
  -moz-border-radius: 5px;
  border-radius: 5px;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 232px;
  /*height: 207px;*/
  cursor: pointer;
  background: #fff;
  float: left;
  margin: 24px 24px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -ms-flex-pack: justify;
  justify-content: space-between;

  .con {
    box-sizing: border-box;
    border-radius: 5px;
    border: 1px solid #e6e6e6;
    padding: 10px;

    .con_right {
      padding: 0 10px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .con_images {
      width: 212px;
      height: 134px;
      border-radius: 5px;
    }

    .con_title {
      font-size: 14px;
      color: #333;
      line-height: 22px;
      height: 44px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      /*设置弹性盒模型子元素的排列方式*/
      -webkit-line-clamp: 2;
      /*限制文本行数*/
      /*white-space: nowrap;      !*超出的空白区域不换行*!*/
      overflow: hidden;
      /*超出隐藏*/
      text-overflow: ellipsis;
      /*文本超出显示省略号*/

      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      /* autoprefixer: off */
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
      -webkit-line-clamp: 2;
    }
  }

  .con_author {
    font-size: 12px;
    font-weight: 300;
    color: #999;
    min-height: 14px;
  }

  .con_org {
    font-size: 12px;
    color: #999;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.details {
  min-height: 100vh;
  min-width: 1280px;

  .details_wrap {
    width: 1280px;
    min-width: 1280px;
    margin: 11px auto 0px;
    overflow: hidden;
    /*height: 6.42rem;*/
    flex-grow: 0;
    z-index: 1;

    .video_ichat {
      width: 860px;
      float: left;
    }

    .line {
      height: 20px;
    }
  }
}

.colOrder {
  margin-right: 20px;
}

.img_text {
  float: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  /*justify-content: flex-end;*/
  p {
    color: #666666;
  }

  >div {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  img {
    cursor: pointer;
    width: 20px;
    height: 20px;
    margin-right: 5px;
    position: relative;
    top: -1px;
  }

  font-size: 14px;
  color: #666666;
}

header {
  min-width: 1280px;
  width: 100%;
  height: 57px;
  border-bottom: 1px solid #a2a2a2;

  .search {
    width: 1280px;
    min-width: 1280px;
    margin: 0 auto;
    box-sizing: border-box;

    a {
      >img {
        width: 50px;
        display: block;
        padding-top: 3px;
      }
    }
  }
}

.nothing {
  width: 200px;
  margin-top: 50px;
  display: inline-block;
}

.cover {
  height: 392px;
  width: 100%;
  border-radius: 20px;

  img {
    width: 100%;
    height: 100%;
    border-radius: 10px;
  }
}

.box {
  /*min-height: 5.4rem;*/
  flex-grow: 1;
  width: 1280px;
  min-width: 1280px;
  margin: 0 auto;
}

.container {
  margin-bottom: 0.98rem;

  .container_item {
    margin-bottom: 0.21rem;
    padding-left: 0.3rem;
    box-sizing: border-box;
    border-bottom: 1px solid #e6e6e6;

    .item_title {
      padding-right: 0.29rem;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      padding-top: 0.16rem;
      padding-bottom: 0.21rem;

      .title_name {
        font-size: 0.26rem;
        color: #666666;
      }

      .title_time {
        font-size: 0.24rem;
        color: #999999;
      }
    }

    .con {
      /*border-bottom: 1px solid #E6E6E6;*/
      box-sizing: border-box;
      padding-bottom: 0.16rem;
      height: 1.77rem;
      display: flex;
      align-items: flex-start;
      flex-shrink: 0;

      .con_right {
        height: 1.62rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }

      .con_images {
        width: 2.84rem;
        height: 1.6rem;
        margin-right: 0.22rem;
      }

      .con_title {
        width: 3.83rem;
        font-size: 0.34rem;
        color: #333333;
        line-height: 0.42rem;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        /*设置弹性盒模型子元素的排列方式*/
        -webkit-line-clamp: 2;
        /*限制文本行数*/
        font-weight: bold;
        /*white-space: nowrap;      !*超出的空白区域不换行*!*/
        overflow: hidden;
        /*超出隐藏*/
        text-overflow: ellipsis;
        /*文本超出显示省略号*/

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        /* autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        -webkit-line-clamp: 2;
      }
    }

    .con_org {
      font-size: 0.26rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 3.83rem;
    }
  }
}

.title {
  width: 100%;
  font-size: 14px;
  line-height: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;

  .line_title {
    color: #333333;
    font-size: 18px;
    font-weight: bold;
    width: 900px;
    max-width: 900px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.navigation {
  width: 1280px;
  min-width: 1280px;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  position: relative;
  margin-top: 10px;
}

.tabmenus {
  width: 750px;
  display: flex;
  color: #666666;
  align-items: center;
  margin: 0 auto;
  z-index: 1;

  li {
    width: 250px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
  }

  li:nth-of-type(2)>span {
    display: inline-block;
    width: 100%;
    line-height: 20px;
    text-align: center;
    border-left: 1px solid #e6e6e6;
  }

  li:nth-of-type(3)>span {
    display: inline-block;
    width: 100%;
    line-height: 20px;
    text-align: center;
    border-left: 1px solid #e6e6e6;
  }

  .active {
    color: #ff781b;
    border-bottom: 1px solid #ff781b;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/column/colDetails.vue